import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faHouseChimney,
  faCircleInfo,
  faGear,
  faEarthAmericas,
  faUsers,
  faPhone,
  faCar,
  faCommentDots,
  faShieldHalved,
  faGift,
  faMoneyBillWave,
  faWrench,
  faTriangleExclamation,
  faCircleQuestion,
  faBullseye,
  faWheelchair,
  faSquareEnvelope
} from '@fortawesome/free-solid-svg-icons'
import { faSquareWhatsapp, faLinkedin, faSquareInstagram } from '@fortawesome/free-brands-svg-icons'

type IconName =
  | 'home'
  | 'info'
  | 'config'
  | 'earth'
  | 'people'
  | 'phone'
  | 'car'
  | 'message'
  | 'shield'
  | 'gift'
  | 'money'
  | 'tool'
  | 'warning'
  | 'question'
  | 'target'
  | 'wheel-chair'
  | 'whatsapp'
  | 'linkedin'
  | 'instagram'
  | 'email'

interface IconsProps {
  name: IconName
  color?: string
  size?: number
  className?: string
}

export const Icons: React.FC<IconsProps> = ({ name, color = '#000', size = 25, className }) => {
  const style = { fontSize: size } as unknown as React.CSSProperties & Record<string, any>
  switch (name) {
    case 'home':
      return <FontAwesomeIcon icon={faHouseChimney} color={color} style={style} className={className} />
    case 'info':
      return <FontAwesomeIcon icon={faCircleInfo} color={color} style={style} className={className} />
    case 'config':
      return <FontAwesomeIcon icon={faGear} color={color} style={style} className={className} />
    case 'earth':
      return <FontAwesomeIcon icon={faEarthAmericas} color={color} style={style} className={className} />
    case 'people':
      return <FontAwesomeIcon icon={faUsers} color={color} style={style} className={className} />
    case 'phone':
      return <FontAwesomeIcon icon={faPhone} color={color} style={style} className={className} />
    case 'car':
      return <FontAwesomeIcon icon={faCar} color={color} style={style} className={className} />
    case 'message':
      return <FontAwesomeIcon icon={faCommentDots} color={color} style={style} className={className} />
    case 'shield':
      return <FontAwesomeIcon icon={faShieldHalved} color={color} style={style} className={className} />
    case 'gift':
      return <FontAwesomeIcon icon={faGift} color={color} style={style} className={className} />
    case 'money':
      return <FontAwesomeIcon icon={faMoneyBillWave} color={color} style={style} className={className} />
    case 'tool':
      return <FontAwesomeIcon icon={faWrench} color={color} style={style} className={className} />
    case 'warning':
      return <FontAwesomeIcon icon={faTriangleExclamation} color={color} style={style} className={className} />
    case 'target':
      return <FontAwesomeIcon icon={faBullseye} color={color} style={style} className={className} />
    case 'wheel-chair':
      return <FontAwesomeIcon icon={faWheelchair} color={color} style={style} className={className} />
    case 'whatsapp':
      return <FontAwesomeIcon icon={faSquareWhatsapp} color={color} style={style} className={className} />
    case 'linkedin':
      return <FontAwesomeIcon icon={faLinkedin} color={color} style={style} className={className} />
    case 'instagram':
      return <FontAwesomeIcon icon={faSquareInstagram} color={color} style={style} className={className} />
    case 'email':
      return <FontAwesomeIcon icon={faSquareEnvelope} color={color} style={style} className={className} />
    default:
      return <FontAwesomeIcon icon={faCircleQuestion} color={color} style={style} className={className} />
  }
}

export default Icons